<template>
    <PrivacyNoticeDialog v-model:open="isOpen" />
    <BaseButton theme="tertiary" size="sm" :disabled="disabled" class="inline-flex items-center gap-1" @click="isOpen = true">
        {{ displayLabel }} <i class="bi bi-lock" aria-hidden="true" />
    </BaseButton>
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import BaseButton from "~vue/components/BaseButton.vue";
import { privacyRowLabel } from "~vue/components/navigation/menuPanes";
import PrivacyNoticeDialog from "~vue/Onboarding/PrivacyNoticeDialog.vue";
import { computed, inject, type Ref, ref } from "vue";

const props = withDefaults(defineProps<{ disabled?: boolean; buttonText?: string }>(), { disabled: false, buttonText: undefined });
const isOpen = ref(false);
const organizationDetails = inject<Ref<OrganizationDetails | null>>("organization_details");
const displayLabel = computed(() => props.buttonText ?? privacyRowLabel(organizationDetails?.value?.privacy_link_label));
</script>
